import React from 'react';
import { useTranslation } from '@/lib/i18n';

interface QuickAction {
  id: string;
  label: string;
  actionType: string;
  actionValue: string;
}

interface QuickActionsProps {
  actions: QuickAction[];
  onMessageAction: (value: string) => void;
  onLinkAction: (url: string) => void;
  onFormAction: (formType: string) => void;
}

export const QuickActions: React.FC<QuickActionsProps> = ({ 
  actions, 
  onMessageAction, 
  onLinkAction, 
  onFormAction 
}) => {
  const { t } = useTranslation();
  if (!actions || actions.length === 0) return null;

  const handleAction = (action: QuickAction) => {
    switch (action.actionType) {
      case 'link':
        onLinkAction(action.actionValue);
        break;
      case 'form':
        onFormAction(action.actionValue);
        break;
      case 'message':
      default:
        onMessageAction(action.actionValue);
        break;
    }
  };

  return (
    <div className="r3c-quick-actions">
      {actions.map((action) => (
        <button
          key={action.id}
          className="r3c-quick-actions__button"
          onClick={() => handleAction(action)}
          title={action.actionType === 'link' ? t('chat.opensInNewTab') : undefined}
        >
          {action.label}
          {action.actionType === 'link' && (
            <span className="r3c-quick-actions__icon">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                <polyline points="15 3 21 3 21 9" />
                <line x1="10" y1="14" x2="21" y2="3" />
              </svg>
            </span>
          )}
        </button>
      ))}
    </div>
  );
};
